/**
 * Get a local storage stored object for a requested key (allow easy persistence of user settings for example)
 * @memberof ParsysRTC.tools
 * @param  {String} key - The field to get the value of
 * @return {Object} the stored object of the requested key
 */
import { DEFAULT_STORAGE_KEY } from 'UTILS/constants';

export function getLocalStorageObject(key) {
  const json = localStorage.getItem(key);
  let obj = {};
  try {
    obj = JSON.parse(json) || {};
  } catch (e) {
    console.error('getLocalStorageObject: failed parsing', key, json);
  }
  return obj;
}

/**
 * Add a local storage stored object for a requested key (allow easy persistence of user settings for example)
 * @memberof ParsysRTC.tools
 * @param  {object} obj - The object to store
 * @param  {String} key - The key where we store the object
 */
export function storeLocalStorageObject(key, obj) {
  try {
    const string = JSON.stringify(obj);
    localStorage.setItem(key, string);
  } catch (e) {
    console.error('storeLocalStorageObject failed serializing', key, obj);
  }
}

export function getDefaultSourceId(type, localStorageKey = DEFAULT_STORAGE_KEY) {
  const rtcConfig = getLocalStorageObject(localStorageKey);
  if (rtcConfig) {
    switch (type) {
      case 'audio':
        return rtcConfig?.defaultAudioSource?.deviceId;
      case 'video':
        return rtcConfig?.defaultVideoSource?.deviceId;
      case 'audioOutput':
        return rtcConfig?.defaultAudioOutput?.deviceId;
    }
  } else {
    return null;
  }
}

export function storeDefaultSourceId(type, deviceId, localStorageKey = DEFAULT_STORAGE_KEY) {
  const persistedSettings = getLocalStorageObject(localStorageKey);
  switch (type) {
    case 'audio':
      persistedSettings.defaultAudioSource = deviceId;
      break;
    case 'video':
      persistedSettings.defaultVideoSource = deviceId;
      break;
    case 'audioOutput':
      persistedSettings.defaultAudioOutput = deviceId;
      break;
  }
  storeLocalStorageObject(DEFAULT_STORAGE_KEY, persistedSettings);
}
